{
  "version": 1,
  "asset_id": "bb1d3cb3-250f-4e6c-9a49-ad96b37b70e7",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/bb1d3cb3-250f-4e6c-9a49-ad96b37b70e7/sweatlab-trvbe.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/bb1d3cb3-250f-4e6c-9a49-ad96b37b70e7/sweatlab-trvbe.webp",
  "original_filename": "sweatlab-trvbe.webp",
  "size": 183358,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:04:24Z"
}
